import Client from './client';

export default class ItemRestrictions extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/item-restrictions`, options);
  }

  post(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/item-restrictions`, {
      ...options,
       method: 'POST',
    });
  }

  putItemByNumber(organization, number, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/item-restrictions/item/${number}`, {
      ...options,
       method: 'PUT',
    });
  }

  deleteItemByNumber(organization, number, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/item-restrictions/item/${number}`, {
      ...options,
       method: 'DELETE',
    });
  }

  putById(organization, id, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/item-restrictions/${id}`, {
      ...options,
       method: 'PUT',
    });
  }

  deleteById(organization, id, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/item-restrictions/${id}`, {
      ...options,
       method: 'DELETE',
    });
  }

}
